import { combineReducers } from "redux";
// import welcomes from "../features/admin/aboutus/welcomes/Slice";
import contact_us from "../features/admin/customers/contact_us/Slice";
import users from "../features/admin/customers/user/Slice";


const customers = combineReducers({
    contact_us: contact_us,
    users:users,
    // welcomes: welcomes,
  });
  
  export default customers;